import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CreatePairingKeyMutationVariables, PairingKeyResponse } from '@uigy/generated/graphql';
import { OtAgentsService } from '@uigy/modules/ot-agents/services/ot-agents.service';
import { NotificationComponent } from '@uigy/shared/components/info/notification.component';
import { PasswordRevealerComponent } from '@uigy/shared/components/password-revealer/password-revealer.component';
import { GenericSliderPage } from '@uigy/shared/components/slider-v2/models/generic-slider-page';
import { ToasterType } from '@uigy/shared/components/toaster/enums/toaster-type.enum';
import { MaterialModule } from '@uigy/shared/material-module/material.module';
import { LanguageService } from '@uigy/shared/services/language.service';
import {
  UiButtonCopyComponent,
} from '@uigy/shared/components/ui-button/button-copy/ui-button-copy.component';
import { I18NextModule } from 'angular-i18next';

@Component({
  standalone: true,
  imports: [
    MaterialModule,
    I18NextModule,
    UiButtonCopyComponent,
    PasswordRevealerComponent,
    NotificationComponent,
    FormsModule,
  ],
  selector: 'app-api-key-get-key-slider',
  templateUrl: './api-key-get-key-slider.component.html',
  styleUrl: './api-key-get-key-slider.component.scss'
})
export class ApiKeyGetKeySliderComponent implements GenericSliderPage<CreatePairingKeyMutationVariables, void> {
  private languageService = inject(LanguageService);
  protected otAgentsService = inject(OtAgentsService);
  protected readonly toasterType = ToasterType;

  public readonly otAgentsTexts = this.languageService.texts.ot_agents;
  public apiKey?: string;

  constructor() {}

  public getData(): void {}

  public initData(data: CreatePairingKeyMutationVariables): void {
    this.otAgentsService.createPairingKey(data).subscribe((res: PairingKeyResponse) => {
      this.apiKey = res.key;
    });
  }

  public isValid(): boolean {
    return true;
  }
}
